export default __webpack_public_path__ + "static/media/HB-headshot-tight-zoom.e9cd5abe.jpg";